import React from 'react';

import { MenuItem, MenuItemProps } from 'common/components/material/MenuList';
import { FormTextFieldProps } from 'common/types/Form.type';
import FormTextField from './FormTextField';

type Option = {
  value: string;
  label: string;
};

type FormSelectProps = FormTextFieldProps & {
  items: Option[];
  menuItemProps?: MenuItemProps;
  SelectProps?: any;
};

const FormSelect: React.FC<FormSelectProps> = ({
  items,
  onChange,
  menuItemProps,
  SelectProps,
  sx,
  ...props
}) => {
  return (
    <FormTextField select onChange={onChange} SelectProps={SelectProps} sx={sx} {...props}>
      {items.map((o: any) => (
        <MenuItem key={o.value} value={o.value} {...menuItemProps}>
          {o.label}
        </MenuItem>
      ))}
    </FormTextField>
  );
};

export default FormSelect;
